import React from "react";
import { motion } from "framer-motion";
import "../theme/theme.css";
import "../css/CTA.css";

export default function CTA() {
  const features = [
    "Unified platform for operations, reporting, and academic management",
    "Secure, role-based access for administrators, teachers, and students",
    "Data-driven insights to improve outcomes and efficiency",
    "Seamless communication across all stakeholders",
    "Scalable architecture suitable for institutions of any size",
    "Structured onboarding and long-term technical support",
  ];

  return (
    <section className="cta-section">
      <div className="cta-bg" />

      <motion.div
        className="cta-wrapper"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        {/* Header */}
        <span className="cta-label">Next Step</span>

        <h2 className="cta-title">
          Ready to Modernize <span>Your Institution</span>?
        </h2>

        <p className="cta-description">
          Inquizene helps educational institutions simplify operations,
          gain clarity through data, and build systems that scale
          confidently over time.
        </p>

        {/* Features */}
        <div className="cta-features">
          {features.map((item, idx) => (
            <div key={idx} className="cta-feature">
              <span className="cta-dot" />
              <p>{item}</p>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="cta-actions">
          <button
            className="btn-primary"
            onClick={() => (window.location.href = "/contact")}
          >
            Start a Conversation
          </button>
          <button className="btn-secondary">
            View Platform Overview
          </button>
        </div>
      </motion.div>
    </section>
  );
}
